import { Box } from "@material-ui/core";
import ButtonChoseList from "components/Common/ButtonChoseList";
import EntitySelectDialog from "components/Common/EntitySelectDialog";
import {
  getParameterByName,
  removeParam,
  updateURLParameter,
} from "helpers/utils";
import React, { useCallback, useEffect, useState } from "react";
import { ApiEndpoint } from "store/@core/endpoint";

export function OptionsFilterPopoverDialog({
  locationSearch,
  setLocationSearch,
  hasMultipleParamName,
  paramName,
  entityType,
  paramButtonTitle,
  paramDialogTitle,
  nameProp,
  valueProp,
  selectedProp,
  sortProp,
}) {
  const hasMultipleParam = getParameterByName(hasMultipleParamName) || "";
  const locNames = getParameterByName(paramName, locationSearch);
  const formatted = locNames?.split(",");
  const [selected, setSelected] = useState(formatted ?? []);
  const [open, setOpen] = useState(false);

  const handleAccept = useCallback(
    (value) => {
      const safeValue = value?.toString() || "";
      let searchParams = removeParam(locationSearch, "hasMultipleParam");
      searchParams = updateURLParameter(searchParams, paramName, safeValue);
      setSelected(value);
      setLocationSearch(searchParams);
    },
    [locationSearch, setLocationSearch]
  );

  //   useEffect(() => {
  //     if (hasMultipleParam) {
  //       const cves = savedCVEsParams.split("=")?.[1];
  //       setSelected(cves?.split(","));
  //     } else if (!hasMultipleParam) {
  //       setSelected([]);
  //     }
  //   }, [savedCVEsParamsAtom, hasMultipleParam]);

  return (
    <Box margin={0}>
      <ButtonChoseList
        title={paramButtonTitle}
        selected={selected}
        onClick={() => setOpen(true)}
      />

      <EntitySelectDialog
        title={paramDialogTitle}
        open={open}
        handleClose={() => setOpen(false)}
        callback={handleAccept}
        entitySelections={selected}
        {...(nameProp && { nameProp })}
        {...(valueProp && { valueProp })}
        {...(selectedProp && { selectedProp })}
        {...(sortProp && { sortProp })}
        url={ApiEndpoint[entityType]}
      />
    </Box>
  );
}
